<template>
  <section v-loading="loading" class="dto">
    <div v-if="data1" class="dto-basic">
      <div />
      <div>
        <com-carousel-hover :imgs="arr" :is-show-vr="false" />
        <com-dto-basic2 :obj="data1" @control="handleControl" />
      </div>
    </div>
    <div class="dto-content">
      <com-tabs
        :list="equipViewInfo.obj.tabs"
        class="dto-content-tabs"
        :default-tab="activeTab"
        @change="changeTab"
      >
        <template v-slot:text="{ obj }">
          <div
            :class="{ activeTab: activeTab == obj.key }"
            class="dto-content-tabs-item"
          >
            {{ obj.name }}
          </div>
        </template>
      </com-tabs>

      <div class="dto-content-item">
        <div v-show="activeTab == 0" class="content-details">
          <span v-if="data1&&data1.desc">
            <div v-html="data1.desc" />
          </span>
          <NullData v-else />
        </div>
        <div v-show="activeTab == 1" class="contentConst">
          <template v-if="data4 && data4.img_url">
            <img v-for="(imgItem,imgIndex) in data4.img_url" :key="imgIndex" :src="imgItem" alt="">
          </template>
          <NullData v-else />
        </div>
        <com-table
          v-show="activeTab == 2"
          :data="data2"
          :configs="equipViewInfo.obj.table1"
          :is-route-dto="true"
          is-route-dto-str="name"
          @path="handleRouteDto1"
        >
          <template v-slot:operate="{ row }">
            <el-button
              type="text"
              @click="handleRouteDto(row, '/proList/details')"
            >
              查看
            </el-button
            >
          </template>
        </com-table>
        <div v-show="activeTab == 3" class="contentConst">
          <template v-if="data1&&data1.const_pic_urls.length">
            <img v-for="(imgItem,imgIndex) in data1.const_pic_urls" :key="imgIndex" :src="imgItem" alt="">
          </template>
          <NullData v-else />
        </div>
        <com-table
          v-show="activeTab == 4"
          :data="data3"
          :configs="equipViewInfo.obj.table2"
          :is-route-dto="true"
          is-route-dto-str="article_name"
          @path="handleRouteDto2"
        >
          <template v-slot:operate="{ row }">
            <el-button
              type="text"
              @click="handleRouteDto(row)"
            >
              查看
            </el-button
            >
          </template>
        </com-table>
        <div v-show="activeTab == 5" class="consult">
          <template v-if="data1&&data1.consult">
            <span v-if="data1.consult">{{ data1.consult }}</span>
          </template>

          <NullData v-else />
        </div>
      </div>
      <div v-if="dialogVisible">
        <el-dialog
          title="标准详情"
          :visible.sync="dialogVisible"
          :fullscreen="true"
          class="fullscreenDialog"
        >
          <StandardDetails
            :row-id="rowId" />
        </el-dialog>
      </div>
    </div>
    <el-dialog
      title=" "
      :visible.sync="editDialog"
      :fullscreen="true"
      :before-close="handleClose"
    >
      <iframe :src="pathValue" frameborder="0" width="100%" height="100%" />
    </el-dialog>
  </section>
</template>

<script>
import api from '@/api/app'
import mock from '@/utils/mock'
import comCarouselHover from '@/components/comCarouselHover'
import comDtoBasic2 from './comDtoBasic2.vue'
import comTabs from '@/components/comTabs'
import comTable from '@/components/comTable'
import StandardDetails from '@/views/notes/standard/details'
import NullData from '@/components/NullData'
import ComCarouselHover from '../../../components/comCarouselHover.vue'
export default {
  components: {
    comCarouselHover,
    comDtoBasic2,
    comTabs,
    comTable,
    StandardDetails,
    NullData,
    ComCarouselHover
  },
  data() {
    return {
      equipInit: mock.square.space.init,
      equipViewInfo: mock.square.space.viewInfo,
      dialogVisible: false,
      activeTab: 0,
      loading: false,
      data1: null,
      data2: null,
      data3: null,
      data4: null, // 建设指南
      params1: {
        collection_type: 2
      },
      params2: {
        design_zb: '',
        page: 1,
        page_size: 100000
      },
      params3: {
        id: 1,
        page: 1,
        page_size: 100000
      },
      params4: {
        id: 1
      },
      arr: [],
      rowId: null,
      editDialog: false,
      pathValue: null

    }
  },
  computed: {},
  watch: {
    $route: {
      handler(val) {
        if (val.query.id) {
          if (this.$route.query.id) {
            this.params1.collection_id = this.$route.query.id
            this.params2.design_zb = this.$route.query.id
            this.params3.id = this.$route.query.id
            this.params4.id = this.$route.query.id
          }
          this.init()
        }
      },
      deep: true
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.params1.collection_id = this.$route.query.id
      this.params2.design_zb = this.$route.query.id
      this.params3.id = this.$route.query.id
      this.params4.id = this.$route.query.id
    }
    this.init()
  },

  methods: {
    handleRouteDto(v, x) {
      if (x) {
        this.$router.push({
          path: x,
          query: {
            id: v.id
          }
        })
      } else {
        this.rowId = v.id
        this.dialogVisible = true
      }
    },
    handleRouteDto1(x, v) {
      if (v == 'name') {
        this.$router.push({
          path: `/proList/details`,
          query: {
            id: x.id
          }
        })
      }
    },
    handleRouteDto2(x, v) {
      if (v == 'article_name') {
        this.$router.push({
          path: `/notes/standard/details`,
          query: {
            id: x.id
          }
        })
      }
    },

    async init() {
      this.loading = true
      if (this.$route.query.id) {
        const id = this.$route.query.id
        this.data1 = await this.equipInit.dto({
          id: id
        })
        // this.arr = this.data1.imgList.slice(0, 7)
        this.arr = this.data1.imgList
        this.data2 = await this.equipInit.proList(this.params2)
        this.data3 = await this.equipInit.about1(this.params3)
        this.data4 = await this.equipInit.wenku(this.params4)
        this.loading = false
        this.equipViewInfo.obj.btns.map((item) => {
          if (item.model == 'evaluate') {
            item.status = this.data1.is_collection == 1 ? 2 : 0
          }
        })
      }
    },
    async handleControl(v) {
      if (v == 'evaluate') {
        this.$confirm('确认收藏吗?', '提示', {})
          .then(() => {
            api.mine.create.collect(this.params1).then((res) => {
              this.$message.success('收藏成功')
              this.init()
            })
          })
          .catch(() => {})
      } else if (v == 'edit') {
        const obj = {}
        obj.design_id = this.data1.new_design_id
        obj.dest = 1
        const src = await this.equipInit.url(obj)
        this.pathValue = src
        this.editDialog = true
        // this.$router.push({
        //   path: '/square/set',
        //   query: {
        //     src
        //   }
        // })
      } else {
        // this.$router.push({
        //   path: '/roam',
        //   query: {
        //     src: this.data1.design_pano_url_ai
        //   }
        // })
        this.pathValue = this.data1.design_pano_url_ai
        this.editDialog = true
      }
    },
    handleClose() {
      this.editDialog = false
      this.pathValue = ''
    },
    control(type, condition) {
      return mock.system.global.control[type](condition)
    },
    changeTab(v) {
      this.activeTab = v
    }
  }
}
</script>

<style scoped lang="scss">
.dto {
  background-color: #f6f6f6;
  padding-top: 30px;
  // overflow-y: scroll;
  // height: calc(100vh - 120px);
  &-basic {
    padding: 20px;
    @include fun-layout(2);
    @include fun-layout();
    > div {
      &:nth-child(1) {
        margin-bottom: 16px;
        font-weight: bold;
      }
      &:nth-child(2) {
        display: flex;
        > section {
          &:nth-child(1) {
            width: 58.62%;
          }
          &:nth-child(2) {
            flex: 1;
          }
        }
      }
    }
  }
  &-content {
    @include fun-layout();
    @include fun-layout(2);
    padding: 20px;
    padding-top: 10px;
    margin-top: 20px;
    min-height: 600px;
    &-tabs {
      margin: 10px 35px;
      &-item {
        text-align: center;
        @include fun-design(6);
        line-height: 40px;
        width: 60px;
        cursor: pointer;
      }
      .activeTab {
        @include fun-active();
      }
    }
    &-item {
      height: calc(100% - 20px);
    }
  }
}
.dto-basic /deep/ .carousel{
  width: 100%;

}
/deep/ .content-details{
  img{
    width: 100% !important;
    // height: auto;
  }
  .noData{
  img{
    width: 200px !important;
  }
}
}
.contentConst{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  img{
    display: block;
    max-width: 100%;
    max-height: 100%;
    margin: 0 auto;
  }
}
/deep/.fullscreenDialog{
  .el-dialog__body{
    height: 100%;
    padding-bottom:80px;
    overflow: auto;
  }
}

.noData{
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 200px;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dto /deep/ .el-dialog__body{
  height: calc(100% - 30px) !important;
}
</style>
